import { createReducer, createStandardAction } from "typesafe-actions";
import { SortState } from "store/filters";
import { AuditEvent } from "../useAuditEvents";

export type AuditEventListState = {
  dataLoaded: boolean;
  selectedItems: string[];
  sort: SortState;
  searchTerm?: string;
  auditEventCount: number;
  auditEvents: AuditEvent[];
};

export const updateDataLoaded = createStandardAction("UpdateDataLoaded")<
  AuditEventListState["dataLoaded"]
>();

export const updateSelectedItems = createStandardAction("UpdateSelectedItems")<
  AuditEventListState["selectedItems"]
>();

export const updateSort = createStandardAction("UpdateSort")<
  AuditEventListState["sort"]
>();

export const updateSearch = createStandardAction("UpdateSearch")<
  AuditEventListState["searchTerm"]
>();

export const updatePageInfo = createStandardAction("UpdatePageInfo")<
  Pick<AuditEventListState, "auditEventCount" | "auditEvents">
>();

export const defaultAuditEventListState: AuditEventListState = {
  dataLoaded: false,
  selectedItems: [],
  sort: {
    field: "eventTime",
    direction: "DESC"
  },
  searchTerm: "",
  auditEventCount: 0,
  auditEvents: []
};

export const AuditEventListReducer = createReducer(defaultAuditEventListState)
  .handleAction(updateDataLoaded, (state, action) => ({
    ...state,
    dataLoaded: action.payload
  }))
  .handleAction(updateSelectedItems, (state, action) => ({
    ...state,
    selectedItems: action.payload
  }))
  .handleAction(updateSort, (state, action) => ({
    ...state,
    sort: action.payload
  }))
  .handleAction(updateSearch, (state, action) => ({
    ...state,
    searchTerm: action.payload
  }))
  .handleAction(updatePageInfo, (state, action) => ({
    ...state,
    ...action.payload
  }));
